export default __webpack_public_path__ + "a795cbe.png";